import { CheckboxFormControl } from 'BrokerTsLib/src/components'
import type { PersonDto } from 'BrokerTsLib/src/dtos'
import { Selection } from 'BrokerTsLib/src/enums'
import { useFormContext } from 'BrokerTsLib/src/rhf'
import { useEffect } from 'react'

import RuianAddressSelector from '@/components/RuianAddressSelector'
import { useApp } from '@/hooks/useApp'
import { FormRow } from '../../containers/forms/FormRow'
import { useNameof } from '../../hooks/useNameof'
import ICOOptions from './person/ICOOptions'
import InsureeAddress from './person/InsureeAddress'
import InsureeName from './person/InsureeName'
import { PersonID } from './person/PersonID'
import PersonType from './person/PersonType'

type PersonFormProps = {
  personPrefix: string,
  disabled?: boolean,
  showAddress?: boolean,
  street?: boolean,
  showVatPayer?: boolean
  useRuian?: boolean
}

export const PersonForm = ({
  personPrefix,
  disabled,
  showAddress = true,
  street = false,
  showVatPayer = false,
  useRuian = true
}: PersonFormProps) => {
  const pnameof = useNameof<PersonDto>(personPrefix)
  const { app } = useApp()
  // const isPoleasPolicyHolder = app == Apps.publicPoleas && kindOfPerson == 'PolicyHolder'

  const { setValue, watch, control } = useFormContext()
  const pType = watch(pnameof(x => x.type))

  useEffect(() => {
    if (!pType)
      setValue(pnameof(x => x.type), Selection.Person)
  }, [pType])

  return (
    <>
      <PersonType personPrefix={personPrefix} disabled={disabled} />

      {showVatPayer && [Selection.Company, Selection.SelfEmployed].includes(pType) &&
        <CheckboxFormControl name={pnameof(x => x.isVatPayer)} control={control} label='Plátce DPH' isDisabled={disabled} />
      }

      {[Selection.Person, Selection.SelfEmployed].includes(pType) &&
        <PersonID personPrefix={personPrefix} disabled={disabled} />
      }

      {[Selection.Company, Selection.SelfEmployed].includes(pType) &&
        <ICOOptions personPrefix={personPrefix} disabled={disabled} />
      }

      {[Selection.Person, Selection.SelfEmployed].includes(pType) &&
        <FormRow>
          <InsureeName personPrefix={personPrefix} disabled={disabled} />
        </FormRow>
      }

      {showAddress && !useRuian &&
        <InsureeAddress
          addressPrefix={pnameof(x => x.address)}
          street={street}
          isDisabled={disabled}
          isDisabledStreet={disabled}
        />}

      {showAddress && useRuian &&
        <RuianAddressSelector
          addressPath={pnameof((x) => x.address)}
          isDisabled={disabled}
          showOnlyLotNumber={false}
        />
      }
    </>
  )
}
